import { User } from "interfaces/user/user";
import { Perimeter } from "interfaces/perimeter/perimeter";

function isNewUser(user: User) {
  return user && user.id === "";
}

function isSelfFromParam(idUser: string) {
  return idUser === null || idUser === undefined;
}

const displayPaywishSection = (perimeter: Perimeter) => perimeter?.companies?.length === 1 && perimeter?.companies?.at(0)?.merchants?.length === 1 && !!perimeter.companies?.at(0)?.merchants?.at(0)?.djmId;

export const createUserUtils = {
  isNewUser,
  isSelfFromParam,
  displayPaywishSection,
}
